import { Component, OnInit, Inject, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { CustomValidators } from 'src/app/shared/directives/custom-validators';
import { INeedMoreHelp } from 'src/app/shared/interfaces/need-more-help';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NeedMoreHelpService } from '../need-more-help.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { validatorLookupRegistry } from '@ptl/forms';

@Component({
    selector: 'app-need-more-help-modal',
    templateUrl: './need-more-help-modal.component.html',
    styleUrls: ['./need-more-help-modal.component.scss'],
    standalone: false
})
export class NeedMoreHelpModalComponent implements OnInit, AfterViewInit {
  needMoreHelpFormGroup: UntypedFormGroup;
  submitting = false;
  postData: INeedMoreHelp;

  @ViewChild("firstname") 
  firstNameInput: ElementRef;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private needMoreHelpService: NeedMoreHelpService,
    private snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<NeedMoreHelpModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      modalTitle: string,
      modalText: string
    }
  ) { }

  ngAfterViewInit(): void {
    // Mat form fields throw afterChangedChecked errors without a short delay here
    setTimeout(() => {
      this.firstNameInput.nativeElement.focus();
    }, 100);
  }

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.needMoreHelpFormGroup = this.formBuilder.group({
      firstName: ['', [Validators.minLength(2), Validators.maxLength(25)]],
      lastName: ['', [Validators.minLength(2), Validators.maxLength(25)]],
      phone: ['', [Validators.minLength(10), CustomValidators.phoneValidator()]],
      email: ['', [validatorLookupRegistry.get('email')]]
    });
  }

  get formControls() {
    return this.needMoreHelpFormGroup.controls;
  }

  submit(e) {
    if (this.needMoreHelpFormGroup.valid === true) {
      this.submitting = true;

      // Success and Error are both coded to say "Success". Not sure if that was intentional or not
      this.needMoreHelpService.postNeedForHelp(this.buildJson()).then(
        this.processSubmitResponse.bind(this), this.processSubmitResponse.bind(this));
    }
  }

  processSubmitResponse() {
    this.snackBar.open(`Successfully submitted.`, 'OK', {
      duration: 5000,
      panelClass: 'positive-panel-class'
    });
    this.closeModal();
  }

  buildJson() {
    return this.postData = {
      LeadRequest: {
        FName: this.needMoreHelpFormGroup.controls['firstName'].value,
        LName: this.needMoreHelpFormGroup.controls['lastName'].value,
        Phone: (this.needMoreHelpFormGroup.controls['phone'].value).replace(/[- )(]/g, ''),
        Zip: '',
        County: '',
        Email: this.needMoreHelpFormGroup.controls['email'].value,
        BestDay: '',
        BestTime: '',
        Over65: '',
        PermCall: '',
        Typaction: ''
      }
    };
  }

  closeModal() {
    this.needMoreHelpFormGroup.reset();
    this.dialogRef.close();
  }
}
